class AutocompleteHelper {
    constructor() {
        this.maxVisibleItems = 767;
        this.currentSelectedItemIndex = -1;
    }

    createContainer(option, parentElement, categoryId) {
        const container = document.createElement("div");
        container.id = `${categoryId}-${option.ref}autocomplete-list`;
        container.className = "autocomplete-items list-group text-left";
        container.setAttribute("tabindex", "-1");
        container.setAttribute("role", "list");
        parentElement.append(container);
    }

    removeAutocompleteItemsExcept(element) {
        const autocompleteItems = document.getElementsByClassName("autocomplete-items");

        if (element) {
            if (!document.getElementById(`${element.getAttribute("data-id")}autocomplete-list`)) {
                this.removeAllAutocompleteItems(autocompleteItems);
            }
        } else {
            this.removeAllAutocompleteItems(autocompleteItems);
        }
    }

    removeAllAutocompleteItems(items) {
        for (let i = 0; i < items.length; i++) {
            items[i].parentNode.removeChild(items[i]);
        }
    }

    createDivElementWithInnerHTML(html) {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    }

    fromAnywhere(event, listeners, inputElement, container, items) {
        const filteredItems = this.filterItems(event.target.value, items);
        this.clearContainer(container);
        if (filteredItems.length === 0) {
            this.showNoResultsMessage(container);
            return;
        }

        this.renderFilteredItems(filteredItems, container, listeners, inputElement);
    }

    filterItems(searchValue, items) {
        const upperSearch = searchValue.toUpperCase();
        return items.filter((item) => {
            if (!item.name) return false;

            const matchIndex = item.name.toUpperCase().indexOf(upperSearch);
            if (matchIndex === -1) return false;

            // Highlight matching text
            item.title = this.highlightMatch(item.name, matchIndex, searchValue.length);
            return true;
        });
    }

    highlightMatch(text, matchIndex, matchLength) {
        return text.slice(0, matchIndex) + "<strong>" + text.slice(matchIndex, matchIndex + matchLength) + "</strong>" + text.slice(matchIndex + matchLength);
    }

    clearContainer(container) {
        while (container.firstChild) {
            container.removeChild(container.lastChild);
        }
    }

    showNoResultsMessage(container) {
        const message = document.createElement("div");
        message.innerHTML = `<span>No Results Found</span>`;
        container.appendChild(message);
    }

    renderFilteredItems(items, container, listeners, inputElement) {
        let currentInitial = "";
        let isFirstItem = true;
        items.forEach((item, index) => {
            // Handle initial grouping if present
            if (item.initial !== undefined) {
                if (isFirstItem) {
                    isFirstItem = false;
                }
                if (isFirstItem || currentInitial !== item.initial) {
                    currentInitial = item.initial;
                    this.renderInitialGroup(container, currentInitial);
                }
            }

            this.renderItem(item, index, container, listeners, inputElement);
        });
    }

    renderInitialGroup(container, initial) {
        const groupElement = document.createElement("div");
        groupElement.className = "initial";
        groupElement.innerHTML = `<strong>${initial.toUpperCase()}</strong>`;
        container.appendChild(groupElement);
    }

    renderItem(item, index, container, listeners, inputElement) {
        const itemElement = document.createElement("div");
        itemElement.className = "list-item list-group-item-action";
        if (index === 0) itemElement.classList.add("active");
        itemElement.dataset.listIndex = index;

        itemElement.innerHTML = `
      <div class='listoption-title ${item.subtitle ? "with-subtitle" : ""}'>
        ${item.title}
      </div>
      <input type="hidden" value="${item.value}" data-title="${item.subtitle || item.title}">
    `;

        this.setupItemEventListeners(itemElement, listeners, inputElement);
        container.appendChild(itemElement);
    }

    setupItemEventListeners(itemElement, listeners, inputElement) {
        itemElement.addEventListener("mouseenter", (e) => {
            this.handleMouseEnter(itemElement, listeners, e);
        });

        itemElement.addEventListener("mouseout", (e) => {
            listeners.option.mouseout?.(e);
        });

        itemElement.addEventListener("click", (e) => {
            this.handleItemClick(itemElement, inputElement, listeners, e);
        });

        // Add other event listeners
        Object.keys(listeners.option).forEach((eventName) => {
            if (!["click", "mouseenter", "mouseout"].includes(eventName)) {
                itemElement.addEventListener(eventName, (e) => {
                    listeners.option[eventName](e);
                });
            }
        });
    }

    handleMouseEnter(itemElement, listeners, event) {
        listeners.option.mouseenter?.(event);

        const previousSelected = document.querySelector(`[data-list-index="${this.currentSelectedItemIndex}"]`);
        if (previousSelected) previousSelected.classList.remove("active");

        this.currentSelectedItemIndex = itemElement.dataset.listIndex;
        itemElement.classList.add("active");
    }

    handleItemClick(itemElement, inputElement, listeners, event) {
        const input = itemElement.getElementsByTagName("input")[0];
        inputElement.value = this.createDivElementWithInnerHTML(input.dataset.title);
        inputElement.dataset.value = input.value;
        inputElement.setAttribute("aria-expanded", "false");

        listeners.option.click?.(event);
        this.removeAutocompleteItemsExcept();
    }
}

export class TireFinderModal {
    constructor(contentElement, flyout, flyoutTrigger) {
        this.contentElement = $(contentElement);
        this.flyoutTrigger = flyoutTrigger;
        this.tireFinderValues = {
            vehicle: { prevRef: [], currentRef: "", tireFinderUrl: "" },
            tireSize: { prevRef: [], currentRef: "", tireFinderUrl: "" },
        };
        this.initialConfigs = [];
        this.autocompleteHelper = new AutocompleteHelper();

        this.initModal();
    }

    initModal() {
        this.setupModalLinks();
        this.handleFlyoutTriggerCases();
        this.initializeTabs(this.contentElement.find(".tirefinder-tabs-modal")[0]);
        this.loadInitialConfig(this.contentElement.find("#tirefinderMaincontainer-modal"));
        this.setupEventListeners();
    }

    setupModalLinks() {
        this.contentElement.find("[aria-controls='vehicle-modal']").attr("href", "#vehicle-modal");
        this.contentElement.find("[aria-controls='tiresize-modal']").attr("href", "#tiresize-modal");
    }

    handleFlyoutTriggerCases() {
        if (this.flyoutTrigger.getAttribute("data-tyre-id") !== null) {
            const tyreId = $(this.flyoutTrigger).data("tyreId");
            this.contentElement.find(".tire-finder").attr("data-tyre-id", tyreId).addClass("rfq-page");
        }

        if (this.flyoutTrigger.getAttribute("data-noredirect") !== null) {
            this.contentElement.find(".tire-finder").addClass("no-redirect");
        }

        if ($(this.flyoutTrigger).hasClass("search-page")) {
            this.contentElement.find(".tire-finder").addClass("search-page");
        }

        if ($(this.flyoutTrigger).hasClass("product-page")) {
            const productId = $(this.flyoutTrigger).data("pid");
            this.contentElement.find(".tire-finder").attr("data-pid", productId).addClass("product-page");
        }

        this.activateDefaultTab();
    }

    activateDefaultTab() {
        if (this.flyoutTrigger.classList.contains("vehicle-Finder")) {
            setTimeout(() => document.getElementById("vehicle-modal-tab").click(), 1000);
        } else if (this.flyoutTrigger.classList.contains("tireSize-Finder")) {
            setTimeout(() => document.getElementById("tiresize-modal-tab").click(), 1000);
        }
    }

    initializeTabs(tabContainer) {
        const tabs = [...tabContainer.querySelectorAll(".enable-tab")];
        const tabPanels = [...document.querySelectorAll(".tirefinderMaincontainer.header .enable-tabpanel")];

        this.setupInitialTabState(tabs, tabPanels);
        this.setupTabKeyboardNavigation(tabs);
        this.setupTabClickHandlers(tabs, tabPanels);
        this.setupTabPanelAccessibility(tabPanels);
    }

    setupInitialTabState(tabs, tabPanels) {
        tabs.forEach((tab) => {
            tab.setAttribute("tabindex", "-1");
            tab.setAttribute("aria-selected", "false");
        });

        let index = 0;
        if (this.flyoutTrigger.classList.contains("vehicle-Finder")) {
            index = 0;
        } else if (this.flyoutTrigger.classList.contains("tireSize-Finder")) {
            index = 0;
        }

        tabs[index].setAttribute("tabindex", "0");
        tabs[index].setAttribute("aria-selected", "true");
        tabPanels[index].classList.add("visible", "active");

        this.updatePanelVisibility(tabs[index], tabPanels);
    }

    setupTabKeyboardNavigation(tabs) {
        const firstTab = tabs[0];
        const lastTab = tabs[tabs.length - 1];

        tabs.forEach((tab) => {
            tab.addEventListener("keydown", (event) => {
                const keyCode = event.keyCode || event.which;
                const isPreviousKey = keyCode === 38 || keyCode === 37; // Up/Left arrow
                const isNextKey = keyCode === 40 || keyCode === 39; // Down/Right arrow

                if (isPreviousKey) {
                    event.preventDefault();
                    this.navigateToTab(tab === firstTab ? lastTab : tabs[tabs.indexOf(tab) - 1]);
                } else if (isNextKey) {
                    event.preventDefault();
                    this.navigateToTab(tab === lastTab ? firstTab : tabs[tabs.indexOf(tab) + 1]);
                }
            });
        });
    }

    navigateToTab(tab) {
        tab.focus();
        tab.click();
    }

    setupTabClickHandlers(tabs, tabPanels) {
        tabs.forEach((tab) => {
            tab.addEventListener("click", () => {
                this.updateTabStates(tab, tabs);
                this.updatePanelVisibility(tab, tabPanels);
            });
        });
    }

    updateTabStates(activeTab, allTabs) {
        allTabs.forEach((tab) => {
            const isSelected = tab.id === activeTab.id;
            tab.setAttribute("tabindex", isSelected ? "0" : "-1");
            tab.setAttribute("aria-selected", isSelected.toString());
        });
    }

    updatePanelVisibility(activeTab, allPanels) {
        allPanels.forEach((panel) => {
            panel.classList.remove("active", "visible");
            panel.hidden = true;
        });
        const activePanel = document.querySelectorAll(`.tirefinderMaincontainer.header [aria-labelledby="${activeTab.id}"]`);
        activePanel.forEach((panel) => {
            panel.classList.add("active", "visible");
            panel.removeAttribute("hidden");
        });
    }

    setupTabPanelAccessibility(panels) {
        panels.forEach((panel) => {
            const hasFocusableElements = panel.querySelectorAll("button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), " + 'textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]), ' + "details:not([disabled]), summary:not(:disabled)").length > 0;

            panel.setAttribute("tabindex", hasFocusableElements ? "-1" : "0");
        });
    }

    loadInitialConfig(container) {
        var tyreId = null;
        if (this.flyoutTrigger.getAttribute("data-tyre-id") !== null) {
            tyreId = $(this.flyoutTrigger).data("tyreId");
        }
        try {
            $.ajax({
                url: wpApiSettings.root + "goodyearforward/v1/tyre-finder/config",
                method: "GET",
                data: tyreId ? {
                    tyreId: tyreId,
                } : {},
                contentType: "application/json",
                dataType: "json",
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("X-WP-Nonce", wpApiSettings.nonce);
                },
                success: (data) => this.setupInitialInputs(container, data.data.initial_config),
                error: () => {}, // Silently handle errors
            });
        } catch (error) {
            console.error("Initial config error:", error);
        }
    }

    setupInitialInputs(container, configData) {
        this.initialConfigs = configData;
        // UI updates
        container.find("div.spinner").remove();
        container.find("div.submit-btn-container").show();

        const vehicleForm = container.find("form.vehicleTireFinder");
        const tireSizeForm = container.find("form.tireSizeTireFinder");

        // this.loadFromCookie();
        this.setupFormInputs(container, configData, vehicleForm, "vehicle");
        this.setupFormInputs(container, configData, tireSizeForm, "tireSize");
    }

    loadFromCookie() {
        try {
            const cookieData = window.getCookie("tireFinderData");
            if (!cookieData) return;

            const tfData = JSON.parse(cookieData);
            const categoryId = tfData.selectorType === "size" ? "tireSize" : "vehicle";

            if (categoryId === "tireSize") {
                this.tireFinderValues[categoryId].prevRef = [tfData.size.width, tfData.size.aspectRatio, tfData.size.rimDiameter];
            } else if (categoryId === "vehicle") {
                this.tireFinderValues[categoryId].prevRef = [tfData.vehicle.refinements.brand, tfData.vehicle.refinements.make, tfData.vehicle.refinements.year, tfData.vehicle.refinements.model];
                this.tireFinderValues[categoryId].size = tfData.vehicle.size;
            }

            this.tireFinderValues[categoryId].tireFinderUrl = tfData.tireFinderUrl;
        } catch (error) {
            console.error("Error loading from cookie:", error);
        }
    }

    setupFormInputs(container, configData, form, categoryId) {
        this.setupInputs(container, configData[categoryId].selectorConfig.initialRef, configData[categoryId].initialRefValues, categoryId, form);
    }

    setupInputs(container, currentRef, currentRefValues, categoryId, form) {
        const options = this.initialConfigs[categoryId].selectorConfig.options;
        console.log(options);
        let inputToSend;
        let optionToSend;
        let indexToSend;
        let isAutoSend = false;
        options.forEach((option, index) => {
            let optionContainer;

            if (this.tireFinderValues[categoryId].prevRef[index]) {
                optionContainer = this.createSelectedValueBlock(container, form, option, index, categoryId);
            } else if (option.ref === currentRef) {
                if (currentRefValues[0].name == "_" && currentRefValues.length == 1) {
                    optionToSend = option;
                    inputToSend = $("<input>");
                    inputToSend.data("value", currentRefValues[0].value);
                    inputToSend.value = currentRefValues[0].name;
                    indexToSend = index;
                    isAutoSend = true;
                } else {
                    optionContainer = this.createActiveInputField(container, form, option, index, currentRefValues, categoryId);
                }
            } else {
                optionContainer = this.createInactiveField(option);
            }

            $(optionContainer).insertBefore(form.find(".submit-btn-container"));
        });

        if (isAutoSend) {
            this.submitOptionInput(container, "", categoryId, inputToSend, optionToSend, indexToSend);
        }
    }

    createSelectedValueBlock(container, form, option, index, categoryId) {
        const optionContainer = $("<div>", {
            class: "gy-input mb-md-0 mt-0 form-fields selected-block mb-lg-0 mr-lg-16 ml-lg-0",
        });

        const button = $("<button>", {
            type: "button",
            "aria-selected": "true",
            class: "border-0 gy-form-control autocomplete selected-value subtitle-small",
            id: `${form.attr("class")}-${option.ref}-${container.attr("id")}`,
            "data-qa-id": `${form.attr("class")}-${option.ref}`,
        });

        button.text(this.tireFinderValues[categoryId].prevRef[index].refDisplayValue);
        button.on("click", () => {
            this.handleSelectedValueClick(container, form, option, index, categoryId);
        });

        if (this.tireFinderValues[categoryId].prevRef[index].refDisplayValue == "_") {
            return;
        }
        return optionContainer.append(button);
    }

    createActiveInputField(container, form, option, index, currentRefValues, categoryId) {
        const isMobile = window.matchMedia("(max-width: 768px)").matches;

        if (isMobile) {
            const optionContainer = document.createElement("div");
            optionContainer.className = "mb-0 mb-lg-8 mb-md-0 mt-0 form-fields active-block mr-lg-16 ml-lg-0";
            optionContainer.innerHTML = option.displayName;
            $(optionContainer).insertBefore(form.find(".submit-btn-container"));
        }

        return this.setupOptionInput(form, option, index, container, currentRefValues, categoryId);
    }

    createInactiveField(option) {
        const optionContainer = document.createElement("div");
        optionContainer.className = "mb-0 mb-lg-8 mt-0 mr-lg-16 ml-lg-0 form-fields mb-md-0";
        optionContainer.setAttribute("data-qa-id", option.ref);
        optionContainer.innerHTML = option.displayName;
        return optionContainer;
    }

    handleSelectedValueClick(container, form, option, index, categoryId) {
        const nonce = container.find("input#tireFinderCSRFToken").val();

        if (option.ref === this.initialConfigs[categoryId].selectorConfig.initialRef) {
            this.resetToInitialState(container, form, option, categoryId);
        } else {
            this.refineSelection(container, form, option, categoryId, nonce);
        }
    }

    resetToInitialState(container, form, option, categoryId) {
        this.tireFinderValues[categoryId].prevRef = [];
        this.tireFinderValues[categoryId].tireFinderUrl = "";
        form.find("div:not(.submit-btn-container)").remove();
        this.setupInputs(container, option.ref, this.initialConfigs[categoryId].initialRefValues, categoryId, form);
    }

    refineSelection(container, form, option, categoryId, nonce) {
        // Remove elements until we find the matching option
        while (true) {
            const removedElement = this.tireFinderValues[categoryId].prevRef.pop();
            if (option.ref === removedElement.refName) break;
        }

        const currentRef = this.tireFinderValues[categoryId].prevRef.pop();
        this.tireFinderValues[categoryId].tireFinderUrl = "";

        const requestData = {
            action: "tirefinder_select_tire_refineBy",
            categId: categoryId,
            currentRef: {
                refName: currentRef.refName,
                refValue: currentRef.refValue,
                refDisplayValue: currentRef.refDisplayValue,
                refIndex: currentRef.refIndex,
            },
            prevRef: this.tireFinderValues[categoryId].prevRef,
            nonce: nonce,
            options: this.initialConfigs[categoryId].selectorConfig.options,
        };

        $.ajax({
            type: "GET",
            url: wpApiSettings.root + "goodyearforward/v1/tyre-finder/refine-options",
            data: requestData,
            dataType: "json",
            beforeSend: function (xhr) {
                xhr.setRequestHeader("X-WP-Nonce", wpApiSettings.nonce);
            },
            success: (response) => this.handleRefinementSuccess(response, container, categoryId),
            error: (error) => console.error("Refinement error:", error),
        });
    }

    handleRefinementSuccess(response, container, categoryId) {
        response = response.data;
        this.tireFinderValues[categoryId].prevRef = response.prevRef;
        this.tireFinderValues[categoryId].currentRef = response.nextRef;
        if (response.tireFinderUrl) {
            const labels = JSON.parse(container.find(".tire-finder.qe-tire-finder-modal").attr("data-labels"));
            container.find(`#${categoryId}-header`).text(labels.tireFinderOtherLabels.letsfindYourTire);
            this.tireFinderValues[categoryId].tireFinderUrl = response.tireFinderUrl;
        }

        const formClass = categoryId === "vehicle" ? "vehicleTireFinder" : "tireSizeTireFinder";
        const form = container.find(`form.${formClass}`);

        form.find("div:not(.submit-btn-container)").remove();
        this.setupInputs(container, response.nextRef, response.refValues, categoryId, form);
    }

    setupOptionInput(form, option, index, container, optionValues, categoryId) {
        const labels = JSON.parse(container.find(".tire-finder.qe-tire-finder-modal").attr("data-labels"));
        const formClass = form.attr("class");

        const fieldContainer = document.createElement("div");
        fieldContainer.className = "gy-input open-input active mb-0 mt-16 mt-lg-0 mr-lg-16 ml-lg-0 form-fields mt-md-16";

        // Create label
        const label = document.createElement("label");
        label.setAttribute("for", `${formClass}-${option.ref}-${container.attr("id")}`);
        label.setAttribute("data-qa-id", `tire-finder-vehicle-modal-label${option.ref}`);
        label.innerHTML = labels[formClass][option.ref].label;
        fieldContainer.append(label);

        // Create input field
        const input = document.createElement("input");
        input.id = `${formClass}-${option.ref}-${container.attr("id")}`;
        input.name = option.ref;
        input.dataset.id = `${formClass}-${option.ref}`;
        input.className = "border-0 gy-form-control autocomplete";
        input.setAttribute("data-qa-id", `tire-finder-vehicle-model-input-${option.ref}`);
        input.type = "text";
        input.required = true;
        input.placeholder = labels[formClass][option.ref].placeholder;
        input.maxLength = labels[formClass][option.ref].maxlength;
        input.setAttribute("aria-describedby", `${formClass}-${option.ref}sr`);
        input.setAttribute("role", "combobox");
        input.setAttribute("aria-expanded", "false");
        input.setAttribute("autocomplete", "off");
        input.setAttribute("aria-atomic", "true");
        fieldContainer.append(input);

        // Set up event listeners
        const listeners = {
            option: {
                click: () => this.submitOptionInput(container, fieldContainer, categoryId, input, option, index),
            },
        };

        input.addEventListener("focus", () => {
            this.handleInputFocus(fieldContainer, formClass, option, listeners, input, optionValues);
        });

        input.addEventListener("input", () => {
            this.handleInputInput(formClass, option, listeners, input, optionValues);
        });

        // Add keypress validation if needed
        const validationPatterns = { year: labels.regex.number };
        if (validationPatterns[option.ref]) {
            input.addEventListener("keypress", (e) => {
                if (!new RegExp(validationPatterns[option.ref]).test(e.key)) {
                    e.preventDefault();
                    return false;
                }
            });
        }

        return fieldContainer;
    }

    handleInputFocus(fieldContainer, formClass, option, listeners, input, optionValues) {
        fieldContainer.classList.remove("gy-input");
        fieldContainer.classList.add("gy-input-active");

        let autocompleteContainer = fieldContainer.querySelector(`#${formClass}-${option.ref}autocomplete-list`);

        if (!autocompleteContainer) {
            this.autocompleteHelper.createContainer(option, fieldContainer, formClass);
            autocompleteContainer = document.querySelector(`#${formClass}-${option.ref}autocomplete-list`);
            this.autocompleteHelper.fromAnywhere({ target: input }, listeners, input, autocompleteContainer, optionValues);
        }
    }

    submitOptionInput(container, fieldContainer, categoryId, input, option, index) {
        const nonce = container.find("input#tireFinderCSRFToken").val();
        const dataValue = $(input).data("value");

        const requestData = {
            action: "tirefinder_select_tire_refineBy",
            categId: categoryId,
            currentRef: {
                refName: option.ref,
                refValue: dataValue,
                refDisplayValue: input.value,
                refIndex: index,
            },
            prevRef: this.tireFinderValues[categoryId].prevRef,
            nonce: nonce,
            options: this.initialConfigs[categoryId].selectorConfig.options,
        };

        if (this.flyoutTrigger.getAttribute("data-tyre-id") !== null) {
            const tyreId = $(this.flyoutTrigger).data("tyreId");
            requestData.tyreId = tyreId;
        }

        $.ajax({
            type: "GET",
            url: wpApiSettings.root + "goodyearforward/v1/tyre-finder/refine-options",
            data: requestData,
            dataType: "json",
            beforeSend: function (xhr) {
                const spinner = $(`<div class="findtire spinner-border ml-4"></div>`);
                $('.form-fields[data-qa-id="' + option.nextRef + '"]').append(spinner);
                $(input).prop("disabled", true);
                xhr.setRequestHeader("X-WP-Nonce", wpApiSettings.nonce);
            },
            success: (response) => this.handleOptionSubmitSuccess(response.data, container, categoryId),
            error: (error) => console.error("Option submit error:", error),
        });
    }

    handleOptionSubmitSuccess(response, container, categoryId) {
        this.tireFinderValues[categoryId].prevRef = response.prevRef;
        this.tireFinderValues[categoryId].currentRef = response.nextRef;
        if (response.tireFinderUrl) {
            const labels = JSON.parse(container.find(".tire-finder.qe-tire-finder-modal").attr("data-labels"));
            container.find(`#${categoryId}-header`).text(labels.tireFinderOtherLabels.letsfindYourTire);
            this.tireFinderValues[categoryId].tireFinderUrl = response.tireFinderUrl;

            if (response.size) {
                this.tireFinderValues[categoryId].size = response.size;
            }
        }

        const formClass = categoryId === "vehicle" ? "vehicleTireFinder" : "tireSizeTireFinder";
        const form = container.find(`form.${formClass}`);
        console.log(formClass);
        form.find("div:not(.submit-btn-container)").remove();
        this.setupInputs(container, response.nextRef, response.refValues, categoryId, form);
    }

    handleInputInput(formClass, option, listeners, input, optionValues) {
        const autocompleteContainer = document.querySelector(`#${formClass}-${option.ref}autocomplete-list`);
        this.autocompleteHelper.fromAnywhere({ target: input }, listeners, input, autocompleteContainer, optionValues);
    }

    submitForm(categoryId, event) {
        console.log(categoryId);
        event.preventDefault();

        if (!this.tireFinderValues[categoryId]?.tireFinderUrl) return;

        $.spinner().start();
        this.setTireFinderCookies(categoryId);

        const tireFinderUrl = this.tireFinderValues[categoryId].tireFinderUrl;
        const isNoRedirect = this.contentElement.find(".tire-finder").hasClass("no-redirect");
        const isProductPage = this.contentElement.find(".tire-finder").hasClass("product-page");

        if (isNoRedirect) {
            this.handleNoRedirectNavigation(tireFinderUrl, categoryId);
        } else if (isProductPage) {
            this.handleNoRedirectNavigation(tireFinderUrl, categoryId);
        } else {
            window.location.href = new URL(tireFinderUrl, window.origin).href;
        }
    }

    handleNoRedirectNavigation(tireFinderUrl, categoryId) {
        const currentUrl = new URL(window.location.href);
        const tireFinderParams = new URL(tireFinderUrl, window.location);

        // Clean up existing params
        if (categoryId === "tireSize") {
            currentUrl.searchParams.delete("vehicleId");
        } else if (categoryId === "vehicle") {
            currentUrl.searchParams.delete("tireSize");
        }

        // Add new params
        for (const [key, value] of tireFinderParams.searchParams.entries()) {
            currentUrl.searchParams.set(key, value);
        }

        window.location.href = currentUrl.href;
    }

    clearForm() {
        // Clear cookies
        window.removeCookie("tireFinderData", { secure: true, expires: 30, path: "/" });

        // Reset forms
        const container = this.contentElement.find("[data-qa-id='tire-finder-comp']");
        const vehicleForm = container.find("form.vehicleTireFinder");
        const tireSizeForm = container.find("form.tireSizeTireFinder");

        vehicleForm.find("div:not(.submit-btn-container)").remove();
        tireSizeForm.find("div:not(.submit-btn-container)").remove();
        //TODO: Remove tyrefinder related url params
        const paramsToRemove = ["tireFinder", "vehicleId", "tireSize"];

        const url = new URL(window.location.href);
        paramsToRemove.forEach((param) => url.searchParams.delete(param));
        window.history.replaceState({}, "", url);
        // Reset state
        this.tireFinderValues = {
            vehicle: { prevRef: [], currentRef: "", tireFinderUrl: "" },
            tireSize: { prevRef: [], currentRef: "", tireFinderUrl: "" },
        };

        // Reinitialize forms
        this.setupInputs(container, this.initialConfigs.vehicle.selectorConfig.initialRef, this.initialConfigs.vehicle.initialRefValues, "vehicle", vehicleForm);
        this.setupInputs(container, this.initialConfigs.tireSize.selectorConfig.initialRef, this.initialConfigs.tireSize.initialRefValues, "tireSize", tireSizeForm);

        window.location.href = url;
    }

    setTireFinderCookies(categoryId) {
        const data = {
            tireFinderUrl: this.tireFinderValues[categoryId].tireFinderUrl,
            selectorType: categoryId === "vehicle" ? "vehicle" : "size",
        };

        if (categoryId === "vehicle") {
            data.vehicle = {
                vehicleId: this.tireFinderValues[categoryId].prevRef[3].refValue,
                size: this.tireFinderValues[categoryId].size,
                refinements: {
                    make: this.tireFinderValues[categoryId].prevRef[0],
                    model: this.tireFinderValues[categoryId].prevRef[1],
                    variant: this.tireFinderValues[categoryId].prevRef[2],
                    year: this.tireFinderValues[categoryId].prevRef[3],
                },
            };
        } else if (categoryId === "tireSize") {
            const [width, aspectRatio, rimDiameter] = this.tireFinderValues[categoryId].prevRef;
            const tireSizeDisplay = `${width.refDisplayValue}/${aspectRatio.refDisplayValue}R${rimDiameter.refDisplayValue}`;
            const tireSizeCode = this.tireFinderValues[categoryId].prevRef.map((item) => item.refDisplayValue).join("-");

            data.size = {
                width: width,
                aspectRatio: aspectRatio,
                rimDiameter: rimDiameter,
                tireSizeCode: tireSizeCode,
                tireSizeDisplay: tireSizeDisplay,
            };
        }
		
		//properly encode json data to avoid block from AFD
		// Convert JSON to string > Encode string to URI component > encode to base64
		const encoded = btoa(encodeURIComponent(JSON.stringify(data)))
        window.setCookie("tireFinderData", encoded, {
            expires: 1,         // 1 days
            secure: true,        // Only send cookie over HTTPS
            path: "/",           // Cookie available throughout the site
            sameSite: "Strict"      // Recommended for security; adjust to "Strict" or "None" as needed
        });
    }

    setupEventListeners() {
        // Handle clicks outside of autocomplete
        document.addEventListener(
            "click",
            (event) => {
                const target = $(event.target);
                const openInputs = $(document).find("div#tirefinderMaincontainer-modal form > div.open-input");

                if (openInputs.length && openInputs !== target && openInputs.find(target).length <= 0) {
                    this.autocompleteHelper.removeAutocompleteItemsExcept();
                }
            },
            true
        );

        // Form events
        $(this.contentElement).find(".custom-auto-complete .submit-btn-container a").on("click", this.clearForm.bind(this));

        $(this.contentElement)
            .find("form.vehicleTireFinder")
            .on("submit", (e) => this.submitForm("vehicle", e));

        $(this.contentElement)
            .find("form.tireSizeTireFinder")
            .on("submit", (e) => this.submitForm("tireSize", e));
    }
}
